export const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: '100%'
  },
  logo: {
    width: '50%',
    alignSelf: 'center',
    marginBottom: 30
  },
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  form: {
    flexBasis: 700,
    justifyContent: 'center',
    flex: 1,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  formSms: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row'
  },
  textField: {
    marginTop: theme.spacing(2),
    borderRadius: 0
  },
  signInButton: {
    margin: theme.spacing(2, 0)
  }
});
